(function () {
  'use strict';

  window.Coop = window.Coop || { Modules: {} };

  Coop.Modules.LocationsMap = {
    defaults: {
      imageBase: window.IMAGES_URL,
      imageExt: '.svg',
      markers: {
        pin: {
          image: 'pin',
          size: [21, 37],
          scaledSize: [21, 37],
        },
        beacon: {
          image: 'beacon',
          size: [29, 29],
          origin: [0, 0],
          anchor: [14, 14],
          scaledSize: [29, 29]
        },
        group: {
          image: 'marker',
          size: [43, 52],
          origin: [-5, -8],
          scaledSize: [33, 40]
        },
        society: {
          image: 'marker-society',
          size: [46, 60],
          origin: [-4, -9],
          scaledSize: [36, 50]
        },
        groupDarkBlue: {
          image: 'marker-finder-dark-blue',
          size: [43, 52],
          origin: [-5, -8],
          scaledSize: [33, 40]
        },
        groupWhite: {
          image: 'marker-finder-white',
          size: [43, 52],
          origin: [-5, -8],
          scaledSize: [33, 40]
        },
      },
      infoWindow: null
    },
    init: function () {
      window.locationsMap = this;
      this.mapElement = document.getElementById('finder-map');
      this.mapDefaults = {
        center: new google.maps.LatLng(53.6186796, -2.1615727),
        disableDefaultUI: true,
        zoom: 12,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        }
      };

      this.map = null;
      this.mapCentre = null;
      this.markers = [];
      this.clusterer = null;
      this.clustererOptions = {
        maxZoom: 12,
        minimumClusterSize: 3,
        averageCenter: true,
        className: 'marker-cluster'
      };
      this.selectedMarker = null;
      this.disableCentreCheck = true;
      this.is_colleague = $('body').hasClass('colleague-finder');
      this.is_fnc = $('body').hasClass('funeralcare-finder');

      this.bindEvents();
      this.initServerSideResults();
      this.setupMap();
    },
    setupMap: function () {
      if (this.map) {
        return;
      }

      this.map = new google.maps.Map(this.mapElement, this.mapDefaults);


      var self = this;
      this.updateUI();

      google.maps.event.addListener(this.map, 'dragend', function () {
        self.checkCentre();
      });
    },
    clearMap: function () {
      if (!this.map) return;

      this.removeMarkers();
      this.removeSearchLocationMarker();
      $('.store-item-clone').remove();
    },
    resetMap: function () {
      if (!this.map) return;

      this.clearMap();
      this.map.setOptions(this.mapDefaults);
    },
    bindEvents: function () {
      var self = this;

      $(window)
        .off('resize.locationsMap')
        .on('resize.locationsMap', function () {
          if (!self.map && self.isDesktop()) {
            var search = locationSearch.currentSearch;
            self.setupMap();

            if (search.coords) {
              self.renderSearchLocationMarker(search.coords.latitude, search.coords.longitude, !!Coop.Modules.Geolocator.currentLocation);
              self.populateMap();
            }
          }

          self.updateUI();
        });

      $('.reload-search')
        .off('click.reloadSearch')
        .on('click.reloadSearch', function () {
          self.reloadSearch();
        });
    },
    isDesktop: function () {
      return $(window).width() >= 750;
    },
    isLandingPage: function() {
      return window.document.URL.search(
        /funeral-directors(\/[^\/]*)?$/
      ) >= 0;
    },
    searchOnMove: function () {
      return $('#search-on-move').is(':checked');
    },
    enableCentreCheck: function () {
      this.mapCentre = this.getVisibleCentre();
      this.disableCentreCheck = false;
    },
    checkCentre: function () {
      if (this.disableCentreCheck) {
        return;
      }

      var newCentre = this.getVisibleCentre();

      if (!this.mapCentre || newCentre.lat() !== this.mapCentre.lat() || newCentre.lng() !== this.mapCentre.lng()) {
        this.mapCentre = newCentre;

        if (this.isDesktop() && this.searchOnMove()) {
          this.reloadSearch();
        }
        else {
          this.showReloadButton();
        }
      }
    },
    getMapOffset: function () {
      return $('.finder-results-list').offset().left + $('.finder-results-list').outerWidth() || 0;
    },
    getVisibleBounds: function () {
      var bounds = this.map.getBounds(),
        projection = this.map.getProjection(),
        offset = this.getMapOffset(),
        northEast,
        southWest,
        northEastPoint,
        southWestPoint,
        pointOffsetX,
        updatedBounds;

      if (projection && this.isDesktop()) {
        southWestPoint = projection.fromLatLngToPoint(bounds.getSouthWest());
        northEastPoint = projection.fromLatLngToPoint(bounds.getNorthEast());
        pointOffsetX = offset / Math.pow(2, this.map.getZoom());
        southWest = projection.fromPointToLatLng(new google.maps.Point(
          southWestPoint.x + pointOffsetX,
          southWestPoint.y
        ));

        northEast = projection.fromPointToLatLng(new google.maps.Point(
          northEastPoint.x,
          northEastPoint.y
        ));


        updatedBounds = new google.maps.LatLngBounds();
        updatedBounds.extend(new google.maps.LatLng(southWest.lat(), southWest.lng()));
        updatedBounds.extend(new google.maps.LatLng(northEast.lat(), northEast.lng()));
        return updatedBounds;
      }

      return bounds;
    },
    getVisibleCentre: function () {
      var self = this,
        visibleBounds = this.getVisibleBounds();

      if (visibleBounds === undefined) {
        google.maps.event.addListenerOnce(locationsMap.map, 'tilesloaded', function () {
          self.fitBounds();
        });
      } else {
        return new google.maps.LatLng(visibleBounds.getCenter().lat(), visibleBounds.getCenter().lng());
      }
    },
    showReloadButton: function () {
      $('.reload-search').addClass('visible');
    },
    reloadSearch: function () {
      var coords = { latitude: this.mapCentre.lat(), longitude: this.mapCentre.lng() };

      Coop.Modules.Geolocator.addressFromCoordinates(coords.latitude, coords.longitude, function (location_data) {
        coords.locality = location_data.locality;
        locationSearch.addToSearchHistory(location_data.formatted_address, coords);
      });
    },
    updateUI: function () {
      if (!this.map) return;

      var isDesktop = this.isDesktop();
      var landingPageMapSettings = {
        "desktop": {
          "center": new google.maps.LatLng(52.36695080494623, -9.599662669025028), "zoom":6.1
        },
        "mobile": {
          "center": new google.maps.LatLng(54.405082, -5.033590), "zoom":5
        }
      };

      var mapSettings = isDesktop ? landingPageMapSettings.desktop : landingPageMapSettings.mobile;

      if (this.isLandingPage()){
        this.map.setOptions(
          Object.assign(
            mapSettings,{
            gestureHandling:"none",
            zoomControl: false
          })
        );
        return;
      } else {
        this.map.setOptions({gestureHandling:"auto"});
      }

      this.map.setOptions({
        zoomControl: isDesktop
      });
    },
    getIcon: function (markerType, index) {
      var icon = {
        url: this.defaults.imageBase + markerType.image + this.defaults.imageExt,
        size: new google.maps.Size(markerType.size[0], markerType.size[1]),
        scaledSize: new google.maps.Size(markerType.scaledSize[0], markerType.scaledSize[1]),
        labelOrigin: new google.maps.Point(21.5, 25)
      };

      if (index) {
        icon.url += '#i=' + index;
      }

      if (markerType.hasOwnProperty('origin')) {
        icon.origin = new google.maps.Point(markerType.origin[0], markerType.origin[1]);
      }

      if (markerType.hasOwnProperty('anchor')) {
        icon.anchor = new google.maps.Point(markerType.anchor[0], markerType.anchor[1]);
      }

      return icon;
    },
    addMarkers: function (results) {
      if (!this.map) return;

      var start = this.markers.length,
        totalCount = start + results.length;

      for (var i = 0; i < results.length; i++) {
        var marker = this.renderMarker(results[i], (i + start), totalCount);
        this.markers.push(marker);
      }

      if (typeof MarkerClusterer === "function") {
        if (this.clusterer) {
          this.clusterer.clearMarkers();
        }
        this.clusterer = new MarkerClusterer(this.map, this.markers, this.clustererOptions);
      }
    },
    removeMarkers: function () {
      $('.reload-search').removeClass('visible');

      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }

      this.markers = [];

      if (typeof MarkerClusterer === "function") {
        if (this.clusterer) {
          this.clusterer.clearMarkers();
        }
      }
    },
    getMarkersFromList: function () {
      var results = [];
      var self = this;

      $('.finder-results-list .store-item').each(function () {
        var latlon = $('[data-store-id]', this).data('latlng').split(','),
          result = {
            position: {
              x: latlon[1],
              y: latlon[0]
            },
            localPageLink: self.buildLocalPageLink(this),
            society: $('.store-index', this).hasClass('is_coop') ? "The Co-operative Group" : "",
          };

        results.push(result);
      });

      return results;
    },
    buildLocalPageLink: function (el) {
      if ($(el).find('.store-more-info').attr('href') !== undefined) {
        return $(el).find('.store-more-info').attr('href');
      } else {
        return $(el).find('.store-header').attr('href');
      }


    },
    initServerSideResults: function () {
      var self = this;

      if (window.SEARCH_LOCATION) {
        this.setupMap();
        this.renderSearchLocationMarker(window.SEARCH_LOCATION.latitude, window.SEARCH_LOCATION.longitude, false);

        if ($('.finder-results-list .store-item').length !== 0 && self.markers.length === 0) {
          self.populateMap();
        }
      }
    },
    populateMap: function (results) {
      var self = this,
        state = window.history.state;
      var checkedResults = results || self.getMarkersFromList();

      this.setupMap();
      this.markers=[];
      this.addMarkers(checkedResults);

      this.fitBounds();

      if (this.selectedMarker) {
        google.maps.event.addListenerOnce(this.map, 'idle', function () {
          self.selectMarker(self.getMarker(this.selectedMarker.index));
        });
      }
    },
    resetBounds: function () {
      this.mapBounds = new google.maps.LatLngBounds();
    },
    fitBounds: function () {
      if (!this.map) return;

      this.disableCentreCheck = true;
      this.resetBounds();

      if (this.markers.length && this.searchLocationMarker) {
        var searchCentre = {
          lat: this.searchLocationMarker.position.lat(),
          lng: this.searchLocationMarker.position.lng()
        };

        this.mapBounds.extend(this.searchLocationMarker.position);

        for (var i = 0; i < this.markers.length; i++) {
          var marker = {
            lat: this.markers[i].position.lat(),
            lng: this.markers[i].position.lng()
          },
            opposite = {
              lat: searchCentre.lat + (searchCentre.lat - marker.lat),
              lng: searchCentre.lng + (searchCentre.lng - marker.lng)
            };
          this.mapBounds.extend(marker);
          this.mapBounds.extend(opposite);
        }

        if (this.isDesktop()) {
          var offset = this.getMapOffset(),
            availableWidth = $(window).width() - offset;

          $(this.mapElement).width(availableWidth);
          google.maps.event.trigger(this.map, 'resize');
          this.map.fitBounds(this.mapBounds);
          $(this.mapElement).width('100%');
          google.maps.event.trigger(this.map, 'resize');
          this.map.panBy(-offset / 2, 0);
        }
        else {
          this.map.fitBounds(this.mapBounds);
          this.map.panBy(0, 0);
        }
      }

      if (this.isDesktop() || $('.tabs-nav [href="#map"]').hasClass('active')) {
        this.enableCentreCheck();
      }
    },
    renderSearchLocationMarker: function (latitude, longitude, geolocated) {
      var self = this,
        title = geolocated ? 'This is your location' : 'This is the centre point<br>of your search',
        markerType = geolocated ? this.defaults.markers.beacon : this.defaults.markers.pin;

      this.setupMap();
      this.removeSearchLocationMarker();

      this.searchLocationMarker = new google.maps.Marker({
        map: self.map,
        position: new google.maps.LatLng(latitude, longitude),
        title: title.replace('<br>', ' '),
        icon: self.getIcon(markerType),
        optimized: false,
        zIndex: 99999999
      });


      this.infowindow = new InfoBox({
        content: title,
        alignBottom: true,
        closeBoxURL: "",
        boxStyle: {
          'width': 'auto',
          'margin-bottom': geolocated ? '18px' : '47px',
          'padding': '5px'
        },
        enableEventPropagation: true
      });

      google.maps.event.addListener(this.searchLocationMarker, 'click', function () {
        self.infowindow.open(self.map, self.searchLocationMarker);
      });

      google.maps.event.addListener(this.map, "click", function () {
        self.infowindow.close();
      });
    },
    removeSearchLocationMarker: function () {
      if (!this.map) return;

      if (this.searchLocationMarker) {
        this.searchLocationMarker.setMap(null);
      }

      if (this.infowindow) {
        this.infowindow.setVisible(false);
      }
    },
    renderMarker: function (result, index, markersCount) {
      var marker,
        is_society = (this.is_colleague && result.society !== "The Co-operative Group"),
        zIndex = ((markersCount - index) * 2) + 10,
        markerType = is_society ? this.defaults.markers.society : this.defaults.markers.groupDarkBlue,
        labelIndex = index + 1,
        markerOptions = {
          index: labelIndex,
          position: new google.maps.LatLng(result.position.y, result.position.x),
          icon: this.getIcon(markerType, labelIndex),
          zIndex: zIndex,
          startZIndex: zIndex,
          label: { text: labelIndex.toString(), color: "#FFFFFF" },
          localPageLink: result.url,
          isSociety: is_society
        };


      if (is_society) {
        markerOptions.labelClass += ' is_society';
      }

      marker = new google.maps.Marker(markerOptions);

      this.bindMarkerEvents(marker);

      return marker;
    },

    bindMarkerEvents: function (marker) {
      var self = this;

      google.maps.event.addListener(marker, 'click', function (event) {
        event.preventBubble=true;
        self.selectMarker(marker);
      });

      google.maps.event.addListener(marker, 'mouseover', function () {
        self.highlightMarker(marker);
      });
      google.maps.event.addListener(marker, 'mouseout', function () {
        self.leaveMarker();
      });

    },
    highlightMarker: function (marker) {
      $('.marker-grow').removeClass('marker-grow');

      var $marker_image = $('img[src="' + marker.icon.url + '"]'),
        $marker_with_label = $('img[src="' + marker.icon.url + '"], .marker-label-' + marker.index);

      if ($marker_image.length) {
        $marker_with_label.addClass('marker-grow');
      }
    },
    leaveMarker: function () {
      $('.marker-shrink').removeClass('marker-shrink');
      $('.marker-grow').removeClass('marker-grow').addClass('marker-shrink');
    },
    selectMarker: function (marker) {
      if (!this.map) return;
      var state = window.history.state;

      this.deselectCurrentMarker();

      if ( typeof marker === 'object') {
        marker.icon.url = this.defaults.imageBase + this.defaults.markers.groupWhite.image + this.defaults.imageExt + '#i=' + marker.index;
        var label = marker.getLabel();
        label.color = "#1F3152";
        marker.setLabel(label);
        marker.setZIndex(100);

        this.addStorePanel(marker);

        this.selectedMarker = marker;
        state.selectedMarker = marker.index;
        window.history.replaceState(state, state.title, state.url);

        if (!this.isMarkerVisible(marker)) {
          this.map.setZoom(this.clustererOptions.maxZoom + 1);
          this.panToMarker(marker);
        }

        if (typeof window.locationsList !== 'undefined') {
          locationsList.openPanel(marker.index, true);

        if (this.is_colleague && this.isDesktop()) {
          locationsList.scrollToPanel(marker.index);
        }
        }
      }
    },
    panToMarker: function (marker) {
      if (!this.map) return;

      var offset = this.getMapOffset(),
        zoomLevel = this.map.getZoom();

      var markerPosition = {
        lat: marker.position.lat(),
        lng: marker.position.lng()
      };

      this.map.setCenter(markerPosition);

      if (zoomLevel !== this.clustererOptions.maxZoom + 1) {
        this.map.setZoom(this.clustererOptions.maxZoom + 1);
      }

      if (this.isDesktop()) {
        this.map.panBy(-offset / 2, 0);
      }
    },
    isMarkerVisible: function (marker) {
      if (!this.isMarkerInBounds(marker)) {
        return false;
      }

      return !this.isMarkerInCluster(marker);


    },
    isMarkerInBounds: function (marker) {
      return this.map.getBounds().contains(marker.getPosition());
    },
    isMarkerInCluster: function (marker) {
      var self = this,
        clusters;
      if (this.clusterer === null) {
        google.maps.event.addListener(this.map, 'idle', function () {
          clusters = self.clusterer.clusters_;
          return this.findMarkerInCluster(clusters, marker);
        });
      } else {
        clusters = this.clusterer.clusters_;
        return this.findMarkerInCluster(clusters, marker);
      }

    },
    findMarkerInCluster: function (clusters, marker) {
      var minClusterSize = this.clustererOptions.minimumClusterSize;

      for (var i = 0; i < clusters.length; i++) {
        var markerArray = clusters[i].markers_;
        if (markerArray !== undefined && markerArray.length >= minClusterSize) {
          for (var j = 0; j < markerArray.length; j++) {
            if (marker.index === markerArray[j].index) {
              return true;
            }
          }
        }
      }
    },
    addStorePanel: function (marker) {
      $('.store-item-clone').remove();

      if (Coop.Modules.AppHeight.isMobileView()) {
        var branch = {
          name: $('[data-store-id=' + marker.index + '] .store-name').text(),
          url: $('[data-store-id=' + marker.index + '] .store-name a').attr('href'),
          address: $('[data-store-id=' + marker.index + '] .store-address').html(),
        };

        if ( this.infoWindow){
          this.infoWindow.close();
        }

        this.infoWindow = new google.maps.InfoWindow({
          content: '<div class="infoBox-mobile" role="status">' +
                      '<a href="' + branch.url + '">' + branch.name + '</a>' +
                      '<p>' + branch.address + '</p>' +
                    '</div>'
        });

        this.infoWindow.open({
          anchor: marker,
          map: this.map,
          shouldFocus: false
        });
      }
    },
    deselectCurrentMarker: function () {
      if (this.selectedMarker) {
        var markerType = this.selectedMarker.isSociety ? this.defaults.markers.society : this.defaults.markers.groupDarkBlue;

        this.selectedMarker.icon.url = this.defaults.imageBase + markerType.image + this.defaults.imageExt + '#i=' + this.selectedMarker.index;

        var label = this.selectedMarker.getLabel();
        label.color = "#FFFFFF";
        this.selectedMarker.setLabel(label);


        this.selectedMarker.setZIndex(this.selectedMarker.startZIndex);
        this.selectedMarker = null;


        $('.store-item-clone').remove();
      }
    },
    getMarker: function (index) {
      for (var i = 0; i < this.markers.length; i++) {
        if (this.markers[i].index === index) {
          return this.markers[i];
        }
      }
    }
  };
})();
